module.exports = __webpack_public_path__ + "static/img/blank@2x.e3f7a2df.png";